import { z } from 'zod';

/**
 * Closed catalog of member opt-in kinds the voice agent can surface through the
 * generic `request_opt_in` tool. Each kind maps, client-side, to a capability
 * that persists the member's choice (and, later, drives the real opt-in — e.g. a
 * scheduled reminder). Adding a new toggle is a new member here plus a
 * capability-registry entry; the agent-facing interface stays one generic tool.
 */
export const optInKindSchema = z.enum(['daily_checkin_reminder']);

export type OptInKind = z.infer<typeof optInKindSchema>;

export const OPT_IN_KINDS = optInKindSchema.options;
